import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BadgeComponent, IconComponent } from '@mode/capra';

@Component({
  selector: 'mode-data-tile',
  standalone: true,
  templateUrl: './data-tile.component.html',
  styleUrls: ['./data-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, IconComponent, BadgeComponent],
})
export class DataTileComponent {
  @Input() title = '';
  @Input() caption = '';
  @Input() badgeText?: string;
  // Optional icon as ng-content

  @Output() clicked = new EventEmitter<void>();

  constructor() {}
}
